import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'creditCardMask'
})
export class CreditCardMaskPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      return '**** **** **** ' + value.substr(value.length-4,4)
    }
  }

}
